// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PostVisitView-module__root___aqOBA {
  display: block;
}

.PostVisitView-module__backButton___EVfoq {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #3f3f46;
  cursor: pointer;
}

.PostVisitView-module__backButton___EVfoq:hover {
  background: #f4f4f5;
}

.PostVisitView-module__titleRow___VEFOR {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.PostVisitView-module__titleGroup___uPDJ2 {
  margin-right: auto;
  min-width: 0;
}

.PostVisitView-module__pageTitle___Q_iyV {
  font-size: 20px;
  font-weight: 600;
  color: #18181b;
  margin: 0;
}

.PostVisitView-module__summaryLine___y5fKg {
  margin: 2px 0 0;
  font-size: 14px;
  color: #71717a;
}

.PostVisitView-module__presetGroup___n8S6H {
  display: flex;
  gap: 4px;
  background: #f4f4f5;
  border-radius: 6px;
  padding: 2px;
}

.PostVisitView-module__presetButton___kpfg4 {
  padding: 3px 10px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 4px;
  border: 1px solid transparent;
  background: transparent;
  color: #71717a;
  cursor: pointer;
}

.PostVisitView-module__presetButton___kpfg4:hover {
  color: #3f3f46;
}

.PostVisitView-module__presetButtonActive___AO7ez {
  background: #ffffff;
  color: #18181b;
  border-color: #e4e4e7;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.PostVisitView-module__listCard___Eu6Ta {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
}

.PostVisitView-module__dayList___Yw4XD {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
}

.PostVisitView-module__emptyState___ThknB {
  margin: 0;
  font-size: 13px;
  color: #71717a;
}

.PostVisitView-module__dayGroup___QkFKf {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.PostVisitView-module__dayRows___YuP26 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/PostVisitView/PostVisitView.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,yCAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AACF;;AACA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAEF","sourcesContent":[".root {\n  display: block;\n}\n\n.backButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 12px;\n  padding: 4px 10px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #e4e4e7;\n  background: #ffffff;\n  color: #3f3f46;\n  cursor: pointer;\n}\n\n.backButton:hover {\n  background: #f4f4f5;\n}\n\n.titleRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.titleGroup {\n  margin-right: auto;\n  min-width: 0;\n}\n\n.pageTitle {\n  font-size: 20px;\n  font-weight: 600;\n  color: #18181b;\n  margin: 0;\n}\n\n.summaryLine {\n  margin: 2px 0 0;\n  font-size: 14px;\n  color: #71717a;\n}\n\n.presetGroup {\n  display: flex;\n  gap: 4px;\n  background: #f4f4f5;\n  border-radius: 6px;\n  padding: 2px;\n}\n\n.presetButton {\n  padding: 3px 10px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #71717a;\n  cursor: pointer;\n}\n\n.presetButton:hover {\n  color: #3f3f46;\n}\n\n.presetButtonActive {\n  background: #ffffff;\n  color: #18181b;\n  border-color: #e4e4e7;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.listCard {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.dayList {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 16px;\n}\n.emptyState {\n  margin: 0;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.dayGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.dayRows {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PostVisitView-module__root___aqOBA`,
	"backButton": `PostVisitView-module__backButton___EVfoq`,
	"titleRow": `PostVisitView-module__titleRow___VEFOR`,
	"titleGroup": `PostVisitView-module__titleGroup___uPDJ2`,
	"pageTitle": `PostVisitView-module__pageTitle___Q_iyV`,
	"summaryLine": `PostVisitView-module__summaryLine___y5fKg`,
	"presetGroup": `PostVisitView-module__presetGroup___n8S6H`,
	"presetButton": `PostVisitView-module__presetButton___kpfg4`,
	"presetButtonActive": `PostVisitView-module__presetButtonActive___AO7ez`,
	"listCard": `PostVisitView-module__listCard___Eu6Ta`,
	"dayList": `PostVisitView-module__dayList___Yw4XD`,
	"emptyState": `PostVisitView-module__emptyState___ThknB`,
	"dayGroup": `PostVisitView-module__dayGroup___QkFKf`,
	"dayRows": `PostVisitView-module__dayRows___YuP26`
};
module.exports = ___CSS_LOADER_EXPORT___;
